export type PlanV2IssueType =
  | 'primary_action'
  | 'topic_ownership'
  | 'freshness'
  | 'serp_competition'
  | 'serp_phrase'
  | 'serp_difficulty'
  | 'serp_intent'
  | 'technical_critical'
  | 'technical_warnings'
  | 'signals'
  | 'internal_link'
  | 'url_ignored';

export type PlanV2IssueQueue = 'issues' | 'work_item' | 'dismissed';

export interface PlanV2IssueCardPayload {
  issueKey: string;
  urlId: string;
  url: string;
  issueType: PlanV2IssueType;
  cardTitle: string;
  changeSummary: string;
  why: string;
  /** Actionable checklist / examples for Work items (multi-line). */
  actionDetail?: string | null;
  /** Internal-link rows: stable id from action plan (`suggestionKey`). */
  suggestionKey?: string | null;
  diagnosisLabel?: string | null;
  priorityScore?: number | null;
}

export interface PlanV2IssueDispositionRecord extends PlanV2IssueCardPayload {
  queue: 'work_item' | 'dismissed';
  updatedAt: string;
}

/** Work items grouped for CMS-style execution (one page → many tasks). */
export interface PlanV2WorkItemsUrlGroup {
  urlId: string;
  url: string;
  priorityScore: number;
  items: PlanV2IssueDispositionRecord[];
}

export function buildPlanV2IssueKey(
  urlId: string,
  issueType: PlanV2IssueType,
  suffix?: string | null
): string {
  const base = `${urlId.trim()}:${issueType}`;
  const extra = (suffix || '').trim();
  return extra ? `${base}:${extra}` : base;
}

export function resolvePlanV2IssueQueue(
  issueKey: string,
  records: Map<string, PlanV2IssueDispositionRecord>
): PlanV2IssueQueue {
  const hit = records.get(issueKey);
  if (!hit) return 'issues';
  return hit.queue;
}

export function isPlanV2IssueVisibleInEmbed(
  issueKey: string,
  records: Map<string, PlanV2IssueDispositionRecord>
): boolean {
  return resolvePlanV2IssueQueue(issueKey, records) === 'issues';
}
